import { ELanguages } from '@static/backend_shared_dicts/enums'

import en from './en.json'
import es from './es.json'
import ru from './ru.json'

/**
 * Переводы лежат статикой рядом с кодом и являются зоной ответственности разработчиков.
 * Ключ перевода — `<Группа>.<Ключ>`, например `AdminPanel.QueuePage`.
 *
 * Массовая заливка из таблицы: `npm run translates:import-csv -- "<путь до csv>"`
 * Проверка полноты словарей: `npm run translates:check`
 *
 * `{ <Группа>: { <Ключ>: <перевод> } }` — тип намеренно широкий, чтобы vue-tsc не выводил литеральные типы для ~2800 ключей
 */
export type ILocaleMessages = Record<string, Record<string, string>>

export const messages: Record<ELanguages, ILocaleMessages> = {
  [ ELanguages.RUSSIAN ]: ru,
  [ ELanguages.ENGLISH ]: en,
  [ ELanguages.SPANISH ]: es,
}

export const FALLBACK_LOCALE = ELanguages.ENGLISH

/** Языки, доступные пользователю в переключателе локали */
export const SUPPORTED_LOCALES: Array<{ culture: ELanguages; name: string }> = [
  { culture: ELanguages.RUSSIAN, name: 'Русский' },
  { culture: ELanguages.ENGLISH, name: 'English' },
  { culture: ELanguages.SPANISH, name: 'Español' },
]
